<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <!-- <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Filtros</b-card-header>
      <b-card-body>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-12">
            <label>Nombre</label>
            <br />
            <base-input v-model="nombreBranchOffice" style="margin-top:10px;"></base-input>
          </div>
          <div class="col-md-12">
            <label>Localidad</label>
            <br />
            <KitsBusquedaSimple url="City/GetTopByText" v-model="City" :currentValue="City" />
          </div>
        </div>
        <div class="row" style="margin-top:20px;">
          <div class="col-md-12 text-right">
            <filter-button @click="filtrar"></filter-button>
          </div>
        </div>
      </b-card-body>
    </b-card>-->

    <KitsFilterCard>
      <div class="row" style="margin-top: 10px">
        <div class="col-md-6">
          <label>Nombre</label>
          <br />
          <base-input
            v-model="nombreBranchOffice"
            placeholder="Ejemplo: Casa Central"
            style="margin-top:10px;"
          ></base-input>
        </div>
        <div class="col-md-6">
          <label>Localidad</label>
          <br />
          <KitsBusquedaSimple url="City/GetByTextAndBranchOffice" v-model="City" :currentValue="City" />
        </div>
      </div>
      <div class="row" style="margin-top:20px;">
        <div class="col-md-12 text-right">
          <filter-button @click="filtrar"></filter-button>
        </div>
      </div>
    </KitsFilterCard>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Sucursales</b-card-header>
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12">
            <base-button
              type="success"
              v-if="hasPermission('Crear Sucursal')"
              @click="crearSucursal()"
            >Crear Sucursal</base-button>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <div style="background-color: white; border-radius: 5px; border: #d6d4d4 1px solid">
              <div
                class="row"
                v-for="item in sucursales"
                v-bind:key="item.EntityID"
                :value="item.EntityID"
                style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
              >
                <div class="col-lg-12 col-md-12">
                  <span
                    style="margin-left: 10px;margin-top: 10px; font-size:42px; float:left;"
                    class="fa fa-fw fa-home"
                  />
                  <div style="margin-left: 10px;margin-top: 22px; margin-bottom:22px; float:left;">
                    <div>{{item.Name}}-{{item.Direction}}</div>
                  </div>
                  <button
                    v-if="hasPermission('Eliminar Sucursal')"
                    type="button"
                    @click="quitarItemClicked(item)"
                    class="btn btn-danger"
                    style="border-bottom:10px;max-width:150px;min-width:150px;margin-top: 22px;float:right"
                  >
                    <i class="fa fa-trash fa-fw"></i>Quitar
                  </button>
                  <button
                    v-if="hasPermission('Editar Sucursal')"
                    type="button"
                    @click="itemClicked(item)"
                    class="btn btn-primary"
                    style="border-bottom:10px;max-width:150px;min-width:150px;margin-left: 10px;margin-top: 22px;float:right"
                  >
                    <i class="fa fa-edit fa-fw"></i>Modificar
                  </button>
                  <button
                    type="button"
                    @click="cashBoxItemClicked(item)"
                    class="btn btn-warning"
                    style="border-bottom:10px;max-width:150px;min-width:150px;margin-left: 10px;margin-top: 22px;float:right"
                  >
                    <i class="fa fa-cash-register fa-fw"></i>Cajas
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

import KitsCombo from "@/components/KitsCombo";
import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";
import KitsFilterCard from "@/components/KitsFilterCard";

import permissionsHelpers from "@/helpers/permissionsHelpers";

export default {
  components: { KitsCombo, KitsBusquedaSimple, KitsFilterCard },
  data() {
    return {
      action: "/sucursales",
      nombreBranchOffice: "",
      City: null,
      model: { Referencia: "", Importe: 0, Aux: "" },
      sucursales: [],
      sucursal: null
    };
  },
  methods: {
    hasPermission(name) {
      return permissionsHelpers.hasPermission(this.action, name);
    },
    crearSucursal() {
      // -- Navegamos a nueva sucursal
      this.$router.push({
        name: "crearsucursal",
        params: { EntityIDProp: 0 }
      });
    },
    filtrar() {
      let context = this;
      var param = {
        CityID: context.City ? context.City.ID : 0,
        Name: context.nombreBranchOffice
      };
      axiosHelpers.axiosPost("Commerce/GetBranchOffices", param, this, function(
        data
      ) {
        context.sucursales = data.ResponseVM.Items;
      });
    },
    cashBoxItemClicked(item) {
      //-- Navegamos a gestion de sucursal
      let self = this;
      self.$router.push({
        name: "administrarcajas",
        params: { EntityIDProp: item.EntityID, SucursalNameProp: item.Name }
      });
    },
    itemClicked(item) {
      //-- Navegamos a gestion de sucursal
      let self = this;
      self.$router.push({
        name: "crearsucursal",
        params: { EntityIDProp: item.EntityID }
      });
    },
    quitarItemClicked(item) {
      //-- Navegamos a gestion de sucursal
      let context = this;
      axiosHelpers.axiosPost(
        "Commerce/RemoveBranchOffice",
        { BranchOfficeID: item.EntityID },
        context,
        function(data) {
          if (data.ResponseVM.Result)
            axiosHelpers.axiosPost(
              "Commerce/GetBranchOffices",
              {},
              context,
              function(Refresh) {
                context.sucursales = Refresh.ResponseVM.Items;
              }
            );
        }
      );
    }
  },
  beforeMount: function() {
    let context = this;

    axiosHelpers.axiosPost("Commerce/GetBranchOffices", {}, this, function(
      data
    ) {
      context.sucursales = data.ResponseVM.Items;
    });
  }
};
</script>